import {
  object,
  array,
  string,
  number,
  boolean,
} from 'yup';

const wordpressImageSchemaSizeObj = object({
  url: string(),
  height: number(),
  width: number(),
  orientation: string(),
});

export const wordpressImageSchema = object({
  id: number().defined(),
  alt: string(),
  author: string(),
  authorLink: string(),
  authorName: string(),
  caption: string(),
  context: string(),
  date: string(),
  dateFormatted: string(),
  // description: string(),
  editLink: string(),
  filename: string(),
  filesizeHumanReadable: string(),
  filesizeInBytes: number(),
  height: number(),
  icon: string(),
  link: string(),
  menuOrder: number(),
  // meta: boolean(),
  mime: string(),
  modified: string(),
  name: string(),
  orientation: string(),
  originalImageName: string(),
  originalImageURL: string(),
  status: string(),
  subtype: string(),
  title: string(),
  type: string(),
  uploadedTo: number(),
  uploadedToLink: string(),
  uploadedToTitle: string(),
  url: string(),
  width: number(),
  nonces: object({
    update: string(),
    delete: string(),
    edit: string(),
  }),
  compat: object({
    item: string(),
    meta: string(),
  }),
  sizes: object({
    thumbnail: wordpressImageSchemaSizeObj,
    medium: wordpressImageSchemaSizeObj,
    full: wordpressImageSchemaSizeObj,
  }),
});

export const mediaBcCarouselSchema = object({
  slides: array().defined().of(object({
    title: string().defined(),
    text: string().defined(),
    image: wordpressImageSchema.defined(),
  })).ensure(),
}).defined();
